/***
 * Function that formats in the french way a number to a currency
 * @param amount number
 * @param minimumFractionDigits number (optional)
 * @description The minimum number of digits after the decimal point. Defaults to 0.
 * @returns string
 * @example
 * formatAmount(123456789) // "123 456 789 €"
 * formatAmount(123456789.123) // "123 456 789 €"
 */
export function formatAmount(amount: number, minimumFractionDigits = 0): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
    minimumFractionDigits: minimumFractionDigits
  }).format(amount);
}
